import { render, staticRenderFns } from "./EstatePlanningSurveyDivorce.vue?vue&type=template&id=f976a518"
import script from "./EstatePlanningSurveyDivorce.vue?vue&type=script&lang=js"
export * from "./EstatePlanningSurveyDivorce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports